export const setLocalStorage = (storageKey: string, storageValue: string) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem(storageKey, storageValue);
  }
};

export const getLocalStorage = (storageKey: string): string | null =>
  typeof window !== 'undefined' ? localStorage.getItem(storageKey) : null;
